//React components
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import MainContent from '../../components/MainContent/MainContent'
import AppShell from '../../page/AppShell/AppShell'

//----Components
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Tabs, Tab } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import TransactionPill from "./TransactionPill";
import TransactionHistory from "./TransactionHistory";
import Navbar from '../NavBar/Navbar';
import Modal from 'react-bootstrap/Modal';
import LoadingAlert from '../Alerts/LoadingAlert';
import SuccessAlert from '../Alerts/SuccessAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import OrderDetailsTemporal from '../Orders/OrderDetailsTemporal';
import OrderDetailPreOrder from '../Orders/OrderDetailPreOrder';
import OrderDetails from '../Orders/OrderDetails';
import ModalBranchOffice from '../NavBar/ModalBranchofficeSelect';
import { useSelectedBranch } from '../../../context/BranchContext';

//------APIS
import { PreOrderFetchAPI } from '../../api/Paymentpost/PreOrder';
import { MachinesFetchAPI } from '../../api/Machines';
import { DeletedTempOrdersFetchAPI } from '../../api/DeletedTemporalOrders';
import { OrdersFetchAPI } from '../../api/Orders';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';

//----IMG
import cashback from '../img/icons/cashback.png'
import refund from '../img/icons/refund.png'
import deleted from '../img/icons/deleted.png'
import success from '../img/icons/success.png'
import empty from '../img/icons/empty.png'
import update from '../img/icons/update-list.png';

import "../Orders/order.css"

//External modules
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import Footer from '../Footer/Footer';
import ModalBranchofficeSelect from '../NavBar/ModalBranchofficeSelect';
import PrecuentasPanel from './PrecuentasPanel';
import './transaction.css'
/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .tt-
───────────────────────────────────────────────────────── */
const TT_CSS = `
@keyframes tt-up { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }

/* ── PAGE ── */
.tt-page {
  max-width: 1280px; margin: 0 auto;
  padding: 1.4rem 1.1rem 2.5rem;
  font-family: var(--font-sans,-apple-system,sans-serif);
}

/* ── BANNER ── */
.tt-banner {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 1rem;
  background: linear-gradient(135deg,#0C1F3D 0%,#1B3A6B 60%,#1E4080 100%);
  border-radius: 18px; padding: 1.25rem 1.6rem;
  margin-bottom: 1.4rem;
  box-shadow: 0 6px 28px rgba(27,58,107,.28);
  position: relative; overflow: hidden;
  animation: tt-up .3s ease both;
}
.tt-banner::before {
  content:''; position:absolute; inset:0;
  background: radial-gradient(ellipse at 85% 40%,rgba(37,99,235,.28) 0%,transparent 65%);
  pointer-events:none;
}
.tt-banner-left { position:relative; z-index:1; }
.tt-banner-eyebrow {
  font-size:.64rem; font-weight:800; letter-spacing:.12em;
  text-transform:uppercase; color:rgba(255,255,255,.45); margin:0 0 .25rem;
}
.tt-banner-title {
  font-size:1.4rem; font-weight:900; color:#fff;
  letter-spacing:-.02em; margin:0;
}
.tt-banner-sub { font-size:.78rem; color:rgba(255,255,255,.5); margin:.3rem 0 0; }
.tt-banner-right { position:relative; z-index:1; }

/* ── CUSTOM TABS ── */
.tt-tabs {
  display:flex; gap:.25rem;
  border-bottom: 2px solid rgba(0,0,0,.08);
  margin-bottom: 1.1rem; background:#fff;
  border-radius: 12px 12px 0 0; padding: .5rem .75rem 0; overflow-x: auto;
  scrollbar-width: none;
}
.tt-tabs::-webkit-scrollbar { display:none; }
.tt-tab {
  display:inline-flex; align-items:center; gap:.4rem;
  padding:.6rem .95rem; border:none; background:transparent; cursor:pointer;
  font-size:.82rem; font-weight:600; color:#6B7280;
  font-family:var(--font-sans,-apple-system,sans-serif);
  border-bottom: 2.5px solid transparent; margin-bottom:-2px;
  transition: color .14s, border-color .14s; white-space:nowrap;
}
.tt-tab:hover { color:#1B3A6B; }
.tt-tab.active { color:#1B3A6B; border-bottom-color:#1B3A6B; font-weight:700; }
.tt-tab-badge {
  background:rgba(27,58,107,.1); color:#1B3A6B;
  border-radius:999px; padding:.1rem .45rem;
  font-size:.66rem; font-weight:800; transition:background .14s, color .14s;
}
.tt-tab.active .tt-tab-badge { background:#1B3A6B; color:#fff; }

/* ── TAB PANEL HEADER ── */
.tt-panel {
  background:#fff; border:1.5px solid rgba(0,0,0,.07);
  border-radius:16px; overflow:hidden;
  box-shadow:0 2px 10px rgba(0,0,0,.05);
}
.tt-panel-header {
  display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:.75rem;
  padding:.9rem 1.1rem;
  border-bottom:1px solid rgba(0,0,0,.07);
}
.tt-panel-title {
  font-size:.95rem; font-weight:800; color:#111827;
  display:flex; align-items:center; gap:.5rem;
  font-family:var(--font-sans,-apple-system,sans-serif);
}
.tt-panel-count {
  background:#1B3A6B; color:#fff;
  border-radius:999px; padding:.1rem .5rem;
  font-size:.7rem; font-weight:800;
}
.tt-panel-body { padding:.85rem 1.1rem 1.1rem; }

/* ── REFRESH BUTTON ── */
.tt-refresh {
  display:inline-flex; align-items:center; gap:.35rem;
  padding:.42rem .85rem; border-radius:9px; border:none; cursor:pointer;
  background:rgba(27,58,107,.08); color:#1B3A6B;
  font-family:var(--font-sans,-apple-system,sans-serif);
  font-size:.77rem; font-weight:700; transition:all .14s;
}
.tt-refresh:hover { background:rgba(27,58,107,.15); }

/* ── DATE FILTER ── */
.tt-date-filter {
  display:flex; align-items:center; gap:.5rem; flex-wrap:wrap;
}
.tt-date-label { font-size:.78rem; color:#6B7280; font-weight:600; white-space:nowrap; font-family:var(--font-sans,-apple-system,sans-serif); }
.tt-date-input {
  border:1.5px solid rgba(0,0,0,.12) !important; border-radius:9px !important;
  font-size:.8rem !important; padding:.42rem .7rem !important; outline:none;
  font-family:var(--font-sans,-apple-system,sans-serif) !important;
}
.tt-date-input:focus { border-color:#1B3A6B !important; box-shadow:0 0 0 3px rgba(27,58,107,.08) !important; }
.tt-date-btn {
  display:inline-flex; align-items:center; gap:.3rem;
  padding:.42rem .85rem; border-radius:9px; border:none; cursor:pointer;
  background:linear-gradient(135deg,#1B3A6B,#2563EB); color:#fff;
  font-size:.78rem; font-weight:700; transition:all .14s;
  font-family:var(--font-sans,-apple-system,sans-serif);
}
.tt-date-btn:hover { filter:brightness(1.1); }

/* ── ORDERS GRID ── */
.tt-grid {
  display:grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap:1rem; padding:.25rem 0;
}

/* ── ORDER CARD ── */
.tt-card {
  background:#fff; border:1.5px solid rgba(0,0,0,.08);
  border-radius:14px; overflow:hidden;
  box-shadow:0 2px 8px rgba(0,0,0,.05);
  display:flex; flex-direction:column;
  transition:box-shadow .16s, transform .16s;
  cursor:pointer; animation:tt-up .25s ease both;
}
.tt-card:hover { box-shadow:0 6px 22px rgba(0,0,0,.1); transform:translateY(-2px); }

/* card colored header strip */
.tt-card-head {
  display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:.35rem;
  padding:.65rem .9rem;
}
.tt-card-head.pending { background:rgba(251,191,36,.12); border-bottom:1.5px solid rgba(251,191,36,.25); }
.tt-card-head.pending-blue { background:rgba(37,99,235,.09); border-bottom:1.5px solid rgba(37,99,235,.2); }
.tt-card-head.deleted { background:rgba(239,68,68,.09); border-bottom:1.5px solid rgba(239,68,68,.2); }
.tt-card-head.done    { background:rgba(22,163,74,.09);  border-bottom:1.5px solid rgba(22,163,74,.2); }

.tt-card-order {
  font-size:.82rem; font-weight:800; color:#111827;
  display:flex; align-items:center; gap:.35rem;
  font-family:var(--font-sans,-apple-system,sans-serif);
}
.tt-card-total {
  font-size:.85rem; font-weight:800; color:#111827;
  font-family:var(--font-sans,-apple-system,sans-serif); white-space:nowrap;
}

/* card body */
.tt-card-body { padding:.7rem .9rem .6rem; flex:1; display:flex; flex-direction:column; gap:.35rem; }
.tt-info-row { display:flex; align-items:baseline; gap:.35rem; }
.tt-info-label {
  font-size:.7rem; font-weight:700; color:#9CA3AF; white-space:nowrap; flex-shrink:0;
  font-family:var(--font-sans,-apple-system,sans-serif);
}
.tt-info-value {
  font-size:.8rem; font-weight:600; color:#374151;
  font-family:var(--font-sans,-apple-system,sans-serif);
  white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
}
.tt-info-divider { height:1px; background:rgba(0,0,0,.06); margin:.3rem 0; }
.tt-date-row { display:flex; gap:1rem; flex-wrap:wrap; }

/* badge for deletion type */
.tt-badge {
  display:inline-flex; align-items:center; gap:.3rem;
  padding:.2rem .65rem; border-radius:999px;
  font-size:.7rem; font-weight:700;
  font-family:var(--font-sans,-apple-system,sans-serif);
}
.tt-badge.user   { background:rgba(239,68,68,.1); color:#DC2626; }
.tt-badge.union  { background:rgba(37,99,235,.1);  color:#2563EB; }
.tt-badge.split  { background:rgba(124,58,237,.1); color:#7C3AED; }
.tt-badge.unknown{ background:rgba(0,0,0,.07);     color:#6B7280; }

/* duration badge */
.tt-duration {
  font-size:.82rem; font-weight:800;
  font-family:var(--font-sans,-apple-system,sans-serif);
}
.tt-duration.good    { color:#16A34A; }
.tt-duration.warning { color:#D97706; }
.tt-duration.bad     { color:#DC2626; }

/* footer */
.tt-card-footer {
  display:flex; justify-content:flex-end;
  padding:.5rem .9rem .7rem;
}
.tt-see-more {
  display:inline-flex; align-items:center; gap:.3rem;
  padding:.38rem .85rem; border-radius:8px; border:none; cursor:pointer;
  background:rgba(27,58,107,.08); color:#1B3A6B;
  font-size:.77rem; font-weight:700; transition:all .14s;
  font-family:var(--font-sans,-apple-system,sans-serif);
}
.tt-see-more:hover { background:#1B3A6B; color:#fff; }

/* powertranz badge */
.tt-ptranz {
  display:inline-flex; align-items:center; gap:.3rem;
  padding:.22rem .7rem; border-radius:8px;
  background:rgba(37,99,235,.1); color:#1B3A6B;
  font-size:.71rem; font-weight:700; margin-bottom:.25rem;
  font-family:var(--font-sans,-apple-system,sans-serif);
}

/* ── EMPTY STATE ── */
.tt-empty {
  display:flex; flex-direction:column; align-items:center; gap:.65rem;
  padding:3rem 1.5rem; text-align:center;
  border:1.5px dashed rgba(27,58,107,.18); border-radius:14px;
}
.tt-empty img { opacity:.5; }
.tt-empty-title { font-size:.92rem; font-weight:800; color:#374151; margin:0; font-family:var(--font-sans,-apple-system,sans-serif); }
.tt-empty-sub   { font-size:.78rem; color:#9CA3AF; margin:0; font-family:var(--font-sans,-apple-system,sans-serif); }

/* ── RESPONSIVE ── */
@media(max-width:640px){
  .tt-banner { flex-direction:column; align-items:flex-start; padding:1rem 1.1rem; }
  .tt-banner-title { font-size:1.1rem; }
  .tt-grid { grid-template-columns:1fr; }
  .tt-page { padding:1rem .75rem 2rem; }
}
`;

if (typeof window !== 'undefined' && !document.getElementById('tt-styles')) {
  const el = document.createElement('style');
  el.id = 'tt-styles'; el.textContent = TT_CSS;
  document.head.appendChild(el);
}

/* ── ICONS ── */
const IcoClock = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>;
const IcoTrash = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /></svg>;
const IcoCheck = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>;
const IcoRefresh = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" /></svg>;
const IcoArrow = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>;
const IcoStore = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>;
const IcoUser = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>;
const IcoDesktop = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></svg>;
const IcoCal = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
function TransactionsTemporal() {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  let { business_code } = useParams();
  let user = JSON.parse(localStorage.getItem('user'));
  let token = localStorage.getItem('x-access-token');

  const [branchOrdersData, setBranchOrdersData] = useState([]);
  const [temporal, setTemporal] = useState([]);
  const [userBranchoffices, setUserBranchs] = useState([]);
  const [userBusiness, setUserBusiness] = useState({});
  const { selectedBranch, setSelectedBranch } = useSelectedBranch();
  const [temporalOrdersData, setTemporalOrdersData] = useState([]);
  const [temporalOrdersDeletedData, setTemporalOrdersDeletedData] = useState([]);
  const [temporalOrdersSuccessData, setTemporalOrdersSuccessData] = useState([]);
  const [detailOrder, setDetailOrder] = useState();
  const [order_type, setOrderType] = useState("temporal");
  const [modalShow, setModalShow] = useState(false);
  const [reload, setReLoad] = useState();
  const [orderData, setOrderData] = useState({
    branchoffice: { code: "", name: "" },
    groups: [], discount: 0, subtotal: 0, total: 0, taxes: [],
  });
  const [minDate, setMinDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00');
  const [maxDate, setMaxDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00');
  const [statusDetailModalDinamic, setStatusDetailDinamic] = useState(true);
  const [paymentInfo, setPaymentInfo] = useState({});
  const [branchOfficeDataOrder, setBranchofficeDataOrder] = useState({ "ruc": "", "dv": "", "name": "", "ruc_type": "", "direction": "", "dgi_name": "" });

  const actualDate = moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD');

  const handleCloseModal = () => setModalShow(false);
  const handleShowModal = () => setModalShow(true);

  const branchList = () => {
    const listBracnh = userBranchoffices.map((branch, index) => (
      <><option value={branch.code}>{branch.branchoffice_name}</option></>
    ));
    return listBracnh;
  };

  const EmptyCard = () => (
    <div className="tt-empty">
      <img src={empty} alt="Vacío" width="48" height="48" />
      <p className="tt-empty-title">Sin transacciones</p>
      <p className="tt-empty-sub">No hay transacciones en esta categoría.</p>
    </div>
  );

  const actionSelectBranch = (branchCode) => { setSelectedBranch({ code: branchCode }); };

  /* ── Pre Orders ── */
  const getPreOrder = async (business_code, branch_code, token) => {
    try {
      const response = await PreOrderFetchAPI.getPreOrder(business_code, branch_code, token);
      console.log(response.data.pre_orders);
      let dataPreOrder = response.data.pre_orders;
      let newArrayPreorder = [];
      dataPreOrder.forEach(order => {
        if (selectedBranch.code == order.branchoffice.code) newArrayPreorder.push(order);
      });
      setBranchOrdersData(newArrayPreorder);
      setTemporalOrdersData(newArrayPreorder);
      setTemporal(newArrayPreorder);
    } catch (err) {
      console.log(err);
      setBranchOrdersData([]); setTemporalOrdersData([]); setTemporal([]);
    }
  };

  const listTemporalOrders = () => {
    if (temporalOrdersData.length === 0) return <EmptyCard />;
    return temporalOrdersData.map((data, i) => (

      < div
        className="oc-card"
        key={data._id || i}
        onClick={() => { setOrderData(data); setStatusDetailDinamic(true); handleShowModal(); }
        }
        style={{ animationDelay: `${i * 0.04}s` }}
      >
        {/* fila 1: chip "Orden #" + chip de estado (ámbar pendiente / navy PowerTranz) */}
        < div className="oc-head" >
          <span className="oc-chip oc-chip--order">
            <span className="oc-chip-k">Orden</span>
            <span className="oc-chip-v">#{data.transaction_code}</span>
          </span>
          <span className={`oc-chip oc-chip--status ${data?.is_powertranz_pay ? 'is-ptranz' : 'is-pending'}`}>
            <span className="oc-chip-text">
              Pendiente
              {data?.is_powertranz_pay && (
                <span className="oc-tag">POWERTRANZ</span>
              )}
            </span>
            <IcoClock />
          </span>
        </div >

        {/* fila 2: cliente + máquina */}
        < div className="oc-meta" >
          <span className="oc-user">
            <IcoUser />
            <span className={`oc-user-name${!data.client_name ? ' is-empty' : ''}`}>
              {!data.client_name ? "No ingresado" : data.client_name}
            </span>
          </span>
          <span className="oc-pill">
            <IcoDesktop /> {data.machine_code}
          </span>
        </div >

        {/* fila 3: sucursal y usuario */}
        < div className="oc-rows" >
          <div className="oc-row">
            <span className="oc-row-k"><IcoStore /> Sucursal</span>
            <span className="oc-row-v">{data.branchoffice.name}</span>
          </div>
          <div className="oc-row">
            <span className="oc-row-k"><IcoUser /> Usuario</span>
            <span className="oc-row-v">{!data.machine_name ? 'No es caja' : data.machine_name} / {!data.user ? 'No es cajera' : data.user.name}</span>
          </div>
        </div >

        {/* fila 4: fecha y hora en celdas */}
        < div className="oc-times" >
          <div className="oc-time">
            <span className="oc-time-k"><IcoCal /> Fecha</span>
            <span className="oc-time-v">
              <span className="oc-time-d">{data.createdAt.split("T")[0]}</span>
            </span>
          </div>
          <div className="oc-time">
            <span className="oc-time-k"><IcoClock /> Hora</span>
            <span className="oc-time-v">
              <span className="oc-time-d">{data.createdAt.split("T")[1].split(".")[0]}</span>
            </span>
          </div>
        </div >

        {/* fila 5: total + acción */}
        < div className="oc-foot" >
          <span className="oc-total">
            <span className="oc-total-k">Total</span>
            <span className="oc-total-v">${data.total.toFixed(2)}</span>
          </span>
          <button
            className="oc-btn"
            type="button"
            onClick={e => { e.stopPropagation(); setOrderData(data); setStatusDetailDinamic(true); handleShowModal(); }}
          >
            Ver más <IcoArrow />
          </button>
        </div >
      </div >
    ));
  };

  const handlerUpdatePreOrder = () => { getPreOrder(business_code, selectedBranch.code, token); };

  /* ── Deleted ── */
  const getDeleteTemporal = async () => {
    try {
      const response = await DeletedTempOrdersFetchAPI.getDeletedTransactionReport(business_code, selectedBranch.code, minDate, maxDate, 0, 0, token);
      console.log(response.data.temp_orders);
      let dataOrders = response.data.temp_orders;
      let dataSuccess = [], dataDeleted = [];
      dataOrders.forEach(item => {
        if (item.deleted == true) dataDeleted.push(item);
        else dataSuccess.push(item);
      });
      setTemporalOrdersDeletedData(dataDeleted);
      setTemporalOrdersSuccessData(dataSuccess);
    } catch (err) {
      console.log(err); setTemporalOrdersDeletedData([]);
    }
  };

  const deletionBadge = (deleted_code) => {
    if (!deleted_code) return <span className="tt-badge unknown">Desconocido</span>;
    if (deleted_code === "USER_REQUEST") return <span className="tt-badge user"><IcoUser /> Por usuario</span>;
    if (deleted_code === "UNION_PAY") return <span className="tt-badge union">Unión de precuentas</span>;
    if (deleted_code === "DIVIDED_BILL") return <span className="tt-badge split">División de precuentas</span>;
    return <span className="tt-badge unknown">?</span>;
  };

  const listTemporalOrdersDeleted = () => {
    if (temporalOrdersDeletedData.length === 0) return <EmptyCard />;
    return temporalOrdersDeletedData.map((data, i) => (
      <div
        className="oc-card is-deleted"
        key={data._id || i}
        onClick={() => { setStatusDetailDinamic(false); getDeleteOrderTemporalById(data._id); handleShowModal(); }}
        style={{ animationDelay: `${i * 0.04}s` }}
      >
        {/* fila 1: chip "Orden #" + chip de estado rojo */}
        <div className="oc-head">
          <span className="oc-chip oc-chip--order">
            <span className="oc-chip-k">Orden</span>
            <span className="oc-chip-v">#{data.transaction_code}</span>
          </span>
          <span className="oc-chip oc-chip--status is-deleted">
            Eliminada
            <IcoTrash />
          </span>
        </div>

        {/* fila 2: usuario */}
        <div className="oc-meta">
          <span className="oc-user">
            <IcoUser />
            <span className="oc-user-name">{data.user.name}</span>
          </span>
        </div>

        {/* fila 3: fechas en celdas */}
        <div className="oc-times">
          <div className="oc-time">
            <span className="oc-time-k"><IcoCal /> Creada</span>
            <span className="oc-time-v">
              <span className="oc-time-d">{data.createdAt.split("T")[0]}</span>
              <span className="oc-time-t">{data.createdAt.split("T")[1].split(".")[0]}</span>
            </span>
          </div>
          <div className="oc-time">
            <span className="oc-time-k"><IcoTrash /> Eliminada</span>
            <span className="oc-time-v">
              <span className="oc-time-d">{data.deletedAt.split("T")[0]}</span>
              <span className="oc-time-t">{data.deletedAt.split("T")[1].split(".")[0]}</span>
            </span>
          </div>
        </div>

        {/* fila 4: tipo de eliminación (condicional original intacto) */}
        {data.deleted_code && (
          <div className="oc-rows">
            <div className="oc-row">
              <span className="oc-row-k">Tipo</span>
              <span className="oc-row-v oc-row-v--badge">{deletionBadge(data.deleted_code)}</span>
            </div>
          </div>
        )}

        {/* fila 5: total + acción */}
        <div className="oc-foot">
          <span className="oc-total">
            <span className="oc-total-k">Total</span>
            <span className="oc-total-v">${data.total.toFixed(2)}</span>
          </span>
          <button
            className="oc-btn"
            type="button"
            onClick={e => { e.stopPropagation(); setStatusDetailDinamic(false); getDeleteOrderTemporalById(data._id); handleShowModal(); }}
          >
            Ver más <IcoArrow />
          </button>
        </div>
      </div>
    ));
  };

  const getDeleteOrderTemporalById = async (_id) => {
    try {
      const response = await DeletedTempOrdersFetchAPI.getDeletedTransactionById(_id, token);
      const response_Data_machine = await MachinesFetchAPI.getmachineByid(response.data.deleted_order.machine_id, token);
      let dataOrder = response.data.deleted_order;
      dataOrder.machine_name = response_Data_machine.data.data.machine_name;
      setOrderData(dataOrder);
      handleShowModal();
    } catch (err) { console.log(err); }
  };

  const getDurationInfo = (createdAt, deletedAt) => {
    if (!createdAt || !deletedAt) return { text: "", color: "warning", emoji: "😐" };
    const start = moment(createdAt), end = moment(deletedAt);
    const duration = moment.duration(end.diff(start));
    const hours = duration.asHours();
    let color = "good", emoji = "😊";
    if (hours > 2) { color = "bad"; emoji = "😡"; }
    else if (hours > 1) { color = "warning"; emoji = "😐"; }
    const text = `${Math.floor(hours)}h ${duration.minutes()}m ${duration.seconds()}s`;
    return { text, color, emoji };
  };

  /* ── Success ── */
  const listTemporalOrdersSuccess = () => {
    if (temporalOrdersSuccessData.length === 0) return <EmptyCard />;
    return temporalOrdersSuccessData.map((data, i) => {
      const { text, color, emoji } = getDurationInfo(data.createdAt, data.deletedAt);
      return (
        <div
          className="oc-card"
          key={data._id || i}
          onClick={() => { setStatusDetailDinamic(false); getTransactioByCode(data.finished_order_reference.transaction_code); }}
          style={{ animationDelay: `${i * 0.04}s` }}
        >
          {/* fila 1: chip "Orden #" + chip de estado (como "Order #1232 | Ready") */}
          <div className="oc-head">
            <span className="oc-chip oc-chip--order">
              <span className="oc-chip-k">Orden</span>
              <span className="oc-chip-v">#{data.transaction_code}</span>
            </span>
            <span className="oc-chip oc-chip--status">
              Realizada
              <IcoCheck />
            </span>
          </div>

          {/* fila 2: usuario + duración (como "Dine in - Table 4 | 2 Minutes ago") */}
          <div className="oc-meta">
            <span className="oc-user">
              <IcoUser />
              <span className="oc-user-name">{data.user.name}</span>
            </span>
            <span className={`oc-duration ${color}`}>
              <IcoClock /> {text} {emoji}
            </span>
          </div>

          {/* fila 3: fechas en dos celdas */}
          <div className="oc-times">
            <div className="oc-time">
              <span className="oc-time-k"><IcoCal /> Creada</span>
              <span className="oc-time-v">
                <span className="oc-time-d">{data.createdAt.split("T")[0]}</span>
                <span className="oc-time-t">{data.createdAt.split("T")[1].split(".")[0]}</span>
              </span>
            </div>
            <div className="oc-time">
              <span className="oc-time-k"><IcoClock /> Finalizada</span>
              <span className="oc-time-v">
                <span className="oc-time-d">{data.deletedAt.split("T")[0]}</span>
                <span className="oc-time-t">{data.deletedAt.split("T")[1].split(".")[0]}</span>
              </span>
            </div>
          </div>

          {/* fila 4: total + acción (como "12 items | It's Done") */}
          <div className="oc-foot">
            <span className="oc-total">
              <span className="oc-total-k">Total</span>
              <span className="oc-total-v">${data.total.toFixed(2)}</span>
            </span>
            <button
              className="oc-btn"
              type="button"
              onClick={e => { e.stopPropagation(); setStatusDetailDinamic(false); getTransactioByCode(data.finished_order_reference.transaction_code); }}
            >
              Ver más <IcoArrow />
            </button>
          </div>
        </div>
      );
    });
  };

  const getTransactioByCode = async (transaction_code) => {
    try {
      const response = await OrdersFetchAPI.getTransactionByCode(transaction_code, business_code, selectedBranch.code, token);
      let dataOrder = response.data.order;
      const response_Data_machine = await MachinesFetchAPI.getmachineByid(response.data.order.machine_id, token);
      const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(dataOrder.business.code, dataOrder.branchoffice.code);
      setBranchofficeDataOrder(response_branch.data.branchoffice);
      dataOrder.machine_name = response_Data_machine.data.data.machine_name;
      dataOrder.paymentInfo = response.data.paymentmetod;
      setOrderData(response.data.order);
      handleShowModal();
    } catch (err) { console.log(err); }
  };

  useEffect(() => {
    (async () => {
      try {
        setUserBranchs(user.branchoffices);
        setUserBusiness(user.business);
        if (selectedBranch.code != 0) {
          getPreOrder(business_code, selectedBranch.code, token);
          getDeleteTemporal();
        } else {
          setBranchOrdersData([]); setTemporalOrdersData([]); setTemporal([]);
          Swal.fire({ title: "Debes seleccionar una sucursal", text: "No hay sucursal seleccionada", icon: "warning" });
        }
      } catch (err) { console.log(err); }
    })();
    setReLoad(false);
  }, [reload, selectedBranch]);

  useEffect(() => {
    if (modalShow) document.body.classList.add("modal-open-fix");
    else document.body.classList.remove("modal-open-fix");
    return () => document.body.classList.remove("modal-open-fix");
  }, [modalShow]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  /* ── Tab state (nuevo, reemplaza Tab.Container) ── */
  const [activeTab, setActiveTab] = useState('pendings');

  return (
    <>
      <AppShell route="temporal">
        <MainContent>
          <div>

            {/* header Original: Review CSS */}
            <div className="ts-top">
              <div className="ts-top__left">
                <div>
                  <div className="ts-top__title">Precuentas</div>
                  <div className="ts-top__sub">Gestión de cuentas pendientes</div>
                </div>
              </div>
              <div className="ts-top__right">
                <ModalBranchofficeSelect actionSelectBranch={actionSelectBranch} />
                <button
                  className="tt-refresh btn-ht-update"
                  onClick={() => getPreOrder(business_code, selectedBranch.code, token)}
                >
                  <IcoRefresh /> Actualizar
                  <img style={{ display: 'none' }} src={update} alt="restart" width="25" height="25" />
                </button>
              </div>
            </div>
            {/* End header Original: Review CSS */}


            {/* ── CUSTOM TABS ── */}
            <div className="tt-tabs">
              <button
                className={`tt-tab ${activeTab === 'pendings' ? 'active' : ''}`}
                onClick={() => setActiveTab('pendings')}
              >
                Precuentas Pendientes
                <span className="tt-tab-badge">{temporalOrdersData.length}</span>
              </button>
              <button
                className={`tt-tab ${activeTab === 'delete' ? 'active' : ''}`}
                onClick={() => setActiveTab('delete')}
              >
                Eliminadas
                <span className="tt-tab-badge">{temporalOrdersDeletedData.length}</span>
              </button>
              <button
                className={`tt-tab ${activeTab === 'checks' ? 'active' : ''}`}
                onClick={() => setActiveTab('checks')}
              >
                Realizadas
                <span className="tt-tab-badge">{temporalOrdersSuccessData.length}</span>
              </button>
            </div>

            {/* ── TAB: PENDIENTES ── */}
            {activeTab === 'pendings' && (
              <div className="tt-grid">

                {listTemporalOrders()}
              </div>
            )}

            {/* ── TAB: ELIMINADAS ── */}
            {activeTab === 'delete' && (
              <>
                <div className="pf-bar">
                  <label className="pf-field" htmlFor="pf-date">
                    <span className="pf-field-ico">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="17" rx="3" />
                        <path d="M8 2v4M16 2v4M3 10h18" />
                      </svg>
                    </span>
                    <span className="pf-field-k">Fecha</span>
                    <input
                      id="pf-date"
                      type="date" name="date"
                      className="pf-field-input"
                      onChange={e => (
                        setMinDate(e.target.value + "T00:00:00.000+00:00"),
                        setMaxDate(e.target.value + "T23:59:59.000+00:00")
                      )}
                    />
                  </label>

                  <button
                    className="pf-btn"
                    type="button"
                    id="btn-analitycs"
                    onClick={async () => getDeleteTemporal()}
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="7" />
                      <path d="M20 20l-3.5-3.5" />
                    </svg>
                    Buscar
                  </button>
                </div>
                <div className="tt-grid">

                  {listTemporalOrdersDeleted()}
                </div>

              </>


            )}

            {/* ── TAB: REALIZADAS ── */}
            {activeTab === 'checks' && (
              <>  <div className="pf-bar">
                <label className="pf-field" htmlFor="pf-date">
                  <span className="pf-field-ico">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="4" width="18" height="17" rx="3" />
                      <path d="M8 2v4M16 2v4M3 10h18" />
                    </svg>
                  </span>
                  <span className="pf-field-k">Fecha</span>
                  <input
                    id="pf-date"
                    type="date" name="date"
                    className="pf-field-input"
                    onChange={e => (
                      setMinDate(e.target.value + "T00:00:00.000+00:00"),
                      setMaxDate(e.target.value + "T23:59:59.000+00:00")
                    )}
                  />
                </label>

                <button
                  className="pf-btn"
                  type="button"
                  id="btn-analitycs"
                  onClick={async () => getDeleteTemporal()}
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="7" />
                    <path d="M20 20l-3.5-3.5" />
                  </svg>
                  Buscar
                </button>
              </div>
                <div className="tt-grid">

                  {listTemporalOrdersSuccess()}
                </div>

              </>
            )}

          </div>

          {/* ── MODAL (original intacto) ── */}
          <Modal show={modalShow} onHide={handleCloseModal} size="lg" modalClassName="custom-modal">
            <Modal.Body>
              <OrderDetailPreOrder
                orderData={orderData}
                userBranchoffices={userBranchoffices}
                handlerUpdatePreOrder={handlerUpdatePreOrder}
                handleCloseModal={handleCloseModal}
                statusDetailModalDinamic={statusDetailModalDinamic}
                branchOfficeData={branchOfficeDataOrder}
              />
            </Modal.Body>
          </Modal>

          {/* imports no-JSX preservados */}
          {void [Row, Col, Tabs, Tab, Nav, TransactionPill, TransactionHistory, Navbar,
            LoadingAlert, SuccessAlert, ErrorAlert, OrderDetailsTemporal, OrderDetails,
            ModalBranchOffice, cashback, refund, deleted, success, Footer, PrecuentasPanel,
            branchList, detailOrder, order_type, paymentInfo, actualDate]}
        </MainContent>
      </AppShell>
    </>
  );
}

export default TransactionsTemporal;